export const ExperimentNames = {
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    DisableMembersSiteCreation: 'specs.events.ui.DisableMembersSiteCreation',
    SelectEventsManually: 'specs.events.ui.SelectEventsManually',
    viewerNoCss: 'specs.events.ui.viewerNoCss',
    DashboardRedesign: 'specs.events.ui.DashboardRedesign',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    NewDashboardReleaseModal: 'specs.events.ui.NewDashboardReleaseModal',
    NewMobileWidgetLayouts: 'specs.events.ui.NewMobileWidgetLayouts',
    NewMobileWidgetSettings: 'specs.events.ui.NewMobileWidgetSettings',
    PublishedListTips: 'specs.events.PublishedListTips',
    EventDetailsMobileUpdate: 'specs.events.ui.DetailsPageMobileUpdate',
    DetailsPageMobileSettings: 'specs.events.ui.DetailsPageMobileSettings',
    DecoupledSeatings: 'specs.seatings.ui.Decoupling',
    BMArticleKeys: 'specs.events.ui.BMArticleKeys',
    EventsCommunityLink: 'specs.events.ui.EventsCommunityLink',
    EventsCommunityLinkEditor: 'specs.events.ui.EventsCommunityLinkEditor',
    PreloadLoadable: 'specs.events.ui.PreloadLoadable',
    MissingSeatingPlanWorkaround: 'specs.events.ui.MissingSeatingPlanWorkaround',
    NewBannerLayout: 'specs.events.BMBannerLayout',
    PreloadSeatingSummary: 'specs.events.ui.PreloadSeatingSummary',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    NotificationV2: 'specs.events.ui.NotificationV2',
    EventsMembersAreaV2: 'specs.events.ui.EventsMembersAreaV2',
};
//# sourceMappingURL=experiments.js.map